import React from 'react';
import { Wrench, FileText } from 'lucide-react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const SalesReturnDashboard = () => {
  const customTiles = [
    {
      id: 'sales-return-refinish',
      title: 'Refinish Bundle Manager',
      description: 'Manage refinishing of returned bundles',
      icon: Wrench,
      iconBg: 'bg-rose-600',
      route: '/sections/sales-return/refinish-bundles',
      testId: 'sales-return-refinish-tile',
      priority: true,
    },
    {
      id: 'sales-return-transactions',
      title: 'Completed Transactions',
      description: 'View all sales-return receipts, filter by date & search',
      icon: FileText,
      iconBg: 'bg-indigo-600',
      route: '/sections/sales-return/transactions',
      testId: 'sales-return-transactions-tile',
    },
  ];

  return (
    <GenericSectionDashboard
      sectionName="Sales Return Section"
      sectionId="sales-return"
      sectionKey="Sales Return"
      description="Return Processing & Restocking"
      backRoute="/"
      customTiles={customTiles}
      moduleId="sales_return"
    />
  );
};

export default SalesReturnDashboard;
